import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

export function ModalFooter({ onCancel, submitLabel }: { onCancel: () => void; submitLabel?: string }) {
  const { t } = useTranslation()
  return (
    <>
      <Button type="button" variant="cancel" onClick={onCancel}>
        {t('common.cancel')}
      </Button>
      <Button type="submit">{submitLabel ?? t('common.save')}</Button>
    </>
  )
}

export function Field({
  id,
  label,
  error,
  className,
  children,
}: {
  id: string
  label: string
  error?: string
  className?: string
  children: ReactNode
}) {
  return (
    <div className={cn('space-y-2', className)}>
      <Label htmlFor={id}>{label}</Label>
      {children}
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  )
}
